<div class="min-h-screen bg-gray-50">
  <div class="flex h-screen bg-gray-50">
    <app-sidebar></app-sidebar>
    <div class="font flex-1 flex flex-col overflow-hidden lg:ml-0">
      <header class="bg-white shadow-sm border-b border-gray-200 p-4 lg:px-6">
        <div class="flex items-center justify-between">
          <button class="lg:hidden text-gray-500 hover:text-gray-700" (click)="toggleMobileMenu()">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="lucide lucide-menu w-6 h-6">
              <line x1="4" x2="20" y1="12" y2="12"></line>
              <line x1="4" x2="20" y1="6" y2="6"></line>
              <line x1="4" x2="20" y1="18" y2="18"></line>
            </svg>
          </button>
          <div class="flex-1 lg:flex lg:items-center lg:justify-between">
            <h2 class="text-lg font-semibold text-gray-900 ml-4 lg:ml-0">{{'SIDEBAR.FORMS' | translate}}</h2>
          </div>
        </div>
      </header>
      <main class="flex-1 overflow-auto p-4 lg:p-6 relative">
        <mat-spinner *ngIf="_applyJobStepperStatusService.isLoading" class="z-10 top-[200px]" [diameter]="60"></mat-spinner>
        <!-- Init View -->
        <div class="space-y-6" *ngIf="!showFormBuilder">
          <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between">
              <div>
                <h1 class="text-2xl font-bold text-gray-900">Job Application Forms</h1>
              </div>
          </div>
          <div class="grid grid-cols-1 sm:grid-cols-3 gap-4">
              <div class="bg-white p-4 rounded-lg border border-gray-200">
                <div class="flex items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-sparkles w-5 h-5 text-blue-600 mr-2">
                      <path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z"></path>
                      <path d="M5 3v4"></path>
                      <path d="M19 17v4"></path>
                      <path d="M3 5h4"></path>
                      <path d="M17 19h4"></path>
                    </svg>
                    <span class="text-sm font-medium text-gray-600">Ready Templates</span>
                </div>
                <p class="text-2xl font-bold text-gray-900 mt-1">4</p>
              </div>
              <div class="bg-white p-4 rounded-lg border border-gray-200">
                <div class="flex items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-clock w-5 h-5 text-green-600 mr-2">
                      <circle cx="12" cy="12" r="10"></circle>
                      <polyline points="12 6 12 12 16 14"></polyline>
                    </svg>
                    <span class="text-sm font-medium text-gray-600">Setup Time</span>
                </div>
                <p class="text-2xl font-bold text-gray-900 mt-1">2 min</p>
              </div>
              <div class="bg-white p-4 rounded-lg border border-gray-200">
                <div class="flex items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-users w-5 h-5 text-purple-600 mr-2">
                      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                      <circle cx="9" cy="7" r="4"></circle>
                      <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
                      <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                    </svg>
                    <span class="text-sm font-medium text-gray-600">Active Forms</span>
                </div>
                <p class="text-2xl font-bold text-gray-900 mt-1">1</p>
              </div>
          </div>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div *ngFor="let stepper of jobForms; let i = index" class="block p-6 rounded-xl border-2 transition-all duration-200 bg-blue-50 border-blue-200 hover:bg-blue-100">
                <div class="flex items-start justify-between mb-4">
                    <div class="flex items-center">
                      <div class="text-2xl mr-4">🧽</div>
                      <div>
                          <h3 class="text-lg font-semibold text-gray-900 cursor-pointer" (click)="onSelectJobForm(stepper, i)">{{stepper.title}}</h3>
                          <p class="text-gray-600 text-sm mt-1">{{stepper.description}}</p>
                      </div>
                    </div>
                    <div class="flex">
                      <button
                        type="button"
                        class="p-2 mr-2 rounded-full bg-white text-blue-600 hover:bg-gray-100 transition"
                        matTooltip="Copy form url to clipboard"
                        matTooltipPosition="above"
                        (click)="copyToClipboard(stepper.uniqueHash)"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          class="h-5 w-5 text-gray-500"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          stroke-width="2"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
                          />
                        </svg>
                      </button>
                      <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-white text-gray-700">{{stepper.jobFormSections.length}} fields</span>
                    </div>

                    <div
                      *ngIf="toastMessage"
                      class="fixed bottom-5 right-5 bg-green-600 text-white px-6 py-3 rounded-lg shadow-lg flex items-center gap-3 animate-slide-in"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                      </svg>
                      <span>{{ toastMessage }}</span>
                    </div>

                </div>
                <div class="flex items-center justify-between cursor-pointer">
                    <span class="text-sm text-gray-500 cursor-pointer" (click)="onSelectJobForm(stepper, i)">Click to customize and activate</span>
                    <div class="flex items-center text-sm font-medium text-blue-600" (click)="onSelectJobForm(stepper, i)">
                      Setup form
                      <svg class="ml-1 w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
                      </svg>
                    </div>
                </div>
              </div>
          </div>

          <div (click)="addNewJobForm()" class="w-[200px] float-right justify-start cursor-pointer mt-8 bg-blue-500 hover:bg-blue-100 text-blue-100 hover:text-blue-700 py-2 px-4 rounded-lg font-medium transition-colors inline-flex items-center">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-plus w-4 h-4 mr-2"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
            Add Job Form
          </div>
        </div>

        <!-- Form Builder -->
         <div class="space-y-6" *ngIf="showFormBuilder">
            <div class="min-h-screen flex flex-col md:flex-row bg-[#f9fafb]">
                <div class="relative flex justify-center w-full px-2 pt-4 md:p-0 md:block md:w-auto">
                    <div class="flex md:justify-center w-full md:w-64 bg-white border-r border-gray-200 p-6 md:h-screen rounded-2xl md:rounded-none overflow-hidden md:overflow-auto lg:block lg:sticky lg:top-0">
                        <app-stepper-navbar (showJobForms)="onHideFormBuilder()" (refreshForms)="getAllForms()"></app-stepper-navbar>
                    </div>
                </div>

                <div class="w-full">
                  <div class="md:container lg:min-w-[1062px] rounded-lg w-full bg-white mb-2 pl-10 pr-10 pt-4 pb-4 space-y-2">
                    <!-- Title Input -->
                    <div class="flex items-center space-x-2 border-b border-gray-200 pb-1">
                       <svg xmlns="http://www.w3.org/2000/svg"
                          class="w-5 h-5 text-gray-600"
                          viewBox="0 0 24 24"
                          fill="currentColor">
                        <text x="4" y="18" font-size="16" font-family="Arial" font-weight="bold">T</text>
                      </svg>
                      <input placeholder="Enter Form name"
                            class="flex-1 bg-transparent border-none outline-none focus:ring-0 p-0" [(ngModel)]="_applyJobStepperStatusService.formTitle" />
                    </div>

                    <!-- Description Input -->
                    <div class="flex items-center space-x-2 border-b border-gray-200 pb-1">
                      <svg xmlns="http://www.w3.org/2000/svg"
                          class="w-5 h-5 text-gray-500"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                              d="M8 9h8M8 13h6M4 5h16M4 19h16"/>
                      </svg>
                      <textarea placeholder="Enter Form description"
                            class="flex-1 bg-transparent border-none h-[24px] outline-none focus:ring-0 p-0" [(ngModel)]="_applyJobStepperStatusService.formDescription"></textarea>
                    </div>
                  </div>

                  <!-- Basic Info -->
                  <form
                    *ngIf="_applyJobStepperStatusService.addedSteps[_applyJobStepperStatusService.activeStep].isDefault"
                    [formGroup]="form"
                    class="md:container lg:min-w-[1062px] h-full w-full rounded-2xl shadow-lg p-10"
                  >
                    <input type="hidden" name="application_id" value="2d4572e6-826c-4b85-81ed-0d55d2a785f2" />
                    <div class="space-y-8">
                      <div>
                        <h2 class="text-2xl font-bold text-gray-900 mb-6 font-['Outfit-bold']">
                          {{ 'JOB_APPLICATIONS.TITLE' | translate }}
                        </h2>
                        <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
                          <!-- First Name -->
                          <div class="relative">
                            <label class="block text-sm font-medium text-gray-700 mb-2 font-['Outfit-medium']">
                              {{ 'JOB_APPLICATIONS.FIRST_NAME' | translate }}
                            </label>
                            <input
                              type="text"
                              formControlName="firstName"
                              placeholder="{{ 'JOB_APPLICATIONS.FIRST_NAME_PLACEHOLDER' | translate }}"
                              class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                            />
                            <p *ngIf="f['firstName'].touched && f['firstName'].invalid" class="absolute text-red-500 text-sm font-['Outfit'] mt-1">
                              {{ 'JOB_APPLICATIONS.FIRST_NAME_REQUIRED' | translate }}
                            </p>
                          </div>

                          <!-- Last Name -->
                          <div class="relative">
                            <label class="block text-sm font-medium text-gray-700 mb-2 font-['Outfit-medium']">
                              {{ 'JOB_APPLICATIONS.LAST_NAME' | translate }}
                            </label>
                            <input
                              type="text"
                              formControlName="lastName"
                              placeholder="{{ 'JOB_APPLICATIONS.LAST_NAME_PLACEHOLDER' | translate }}"
                              class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                            />
                            <p *ngIf="f['lastName'].touched && f['lastName'].invalid" class="absolute text-red-500 text-sm mt-1">
                              {{ 'JOB_APPLICATIONS.LAST_NAME_REQUIRED' | translate }}
                            </p>
                          </div>

                          <!-- Email -->
                          <div class="relative">
                            <label class="block text-sm font-medium text-gray-700 mb-2 font-['Outfit-medium']">
                              {{ 'JOB_APPLICATIONS.EMAIL' | translate }}
                            </label>
                            <div class="relative">
                              <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                <!-- Icon -->
                                <svg class="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    d="M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207"
                                  />
                                </svg>
                              </div>
                              <input
                                type="email"
                                formControlName="email"
                                placeholder="{{ 'JOB_APPLICATIONS.EMAIL_PLACEHOLDER' | translate }}"
                                class="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                              />
                            </div>
                            <p *ngIf="f['email'].touched && f['email'].errors?.['required']" class="absolute text-red-500 text-sm mt-1">
                              {{ 'JOB_APPLICATIONS.EMAIL_REQUIRED' | translate }}
                            </p>
                            <p *ngIf="f['email'].touched && f['email'].errors?.['email']" class="absolute text-red-500 text-sm mt-1">
                              {{ 'JOB_APPLICATIONS.EMAIL_INVALID' | translate }}
                            </p>
                          </div>

                          <!-- Phone -->
                          <div class="relative">
                            <label class="block text-sm font-medium text-gray-700 mb-2 font-['Outfit-medium']">
                              {{ 'JOB_APPLICATIONS.PHONE' | translate }}
                            </label>
                            <div class="relative">
                              <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                <!-- Icon -->
                                <svg class="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                                  />
                                </svg>
                              </div>
                              <input
                                (input)="formatPhone($event)"
                                type="tel"
                                formControlName="phone"
                                placeholder="{{ 'JOB_APPLICATIONS.PHONE_PLACEHOLDER' | translate }}"
                                maxlength="12"
                                class="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                              />
                            </div>
                            <p *ngIf="f['phone'].touched && f['phone'].errors?.['required']" class="absolute text-red-500 text-sm mt-1">
                              {{ 'JOB_APPLICATIONS.PHONE_REQUIRED' | translate }}
                            </p>
                            <p *ngIf="f['phone'].touched && f['phone'].errors?.['pattern']" class="absolute text-red-500 text-sm mt-1">
                              {{ 'JOB_APPLICATIONS.PHONE_INVALID' | translate }}
                            </p>
                          </div>
                        </div>

                        <!-- Address -->
                        <div class="mt-8">
                          <h3 class="text-lg font-semibold text-gray-900 mb-4 font-['Outfit-medium']">
                            {{ 'JOB_APPLICATIONS.ADDRESS' | translate }}
                          </h3>
                          <div class="grid grid-cols-1 md:grid-cols-4 gap-4">
                            <!-- Street Address -->
                            <div class="md:col-span-3 relative">
                              <label class="block text-sm font-medium text-gray-700 mb-2 font-['Outfit-medium']">
                                {{ 'JOB_APPLICATIONS.STREET_ADDRESS' | translate }}
                              </label>
                              <div class="relative">
                                <input
                                  type="text"
                                  formControlName="streetAddress"
                                  placeholder="{{ 'JOB_APPLICATIONS.STREET_PLACEHOLDER' | translate }}"
                                  class="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                />
                              </div>
                              <p *ngIf="f['streetAddress'].touched && f['streetAddress'].invalid" class="absolute text-red-500 text-sm mt-1">
                                {{ 'JOB_APPLICATIONS.STREET_REQUIRED' | translate }}
                              </p>
                            </div>

                            <!-- Apt/Suite -->
                            <div class="relative">
                              <label class="block text-sm font-medium text-gray-700 mb-2 font-['Outfit-medium']">
                                {{ 'JOB_APPLICATIONS.APT_SUITE' | translate }}
                              </label>
                              <input
                                type="text"
                                formControlName="aptSuite"
                                placeholder="{{ 'JOB_APPLICATIONS.APT_PLACEHOLDER' | translate }}"
                                class="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                              />
                            </div>
                          </div>

                          <div class="grid grid-cols-1 md:grid-cols-3 gap-4 mt-8">
                            <!-- City -->
                            <div class="relative">
                              <label class="block text-sm font-medium text-gray-700 mb-2 font-['Outfit-medium']">
                                {{ 'JOB_APPLICATIONS.CITY' | translate }}
                              </label>
                              <input
                                type="text"
                                formControlName="city"
                                placeholder="{{ 'JOB_APPLICATIONS.CITY_PLACEHOLDER' | translate }}"
                                class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                              />
                              <p *ngIf="f['city'].touched && f['city'].invalid" class="absolute text-red-500 text-sm mt-1">
                                {{ 'JOB_APPLICATIONS.CITY_REQUIRED' | translate }}
                              </p>
                            </div>

                            <!-- State -->
                            <div class="relative">
                              <label class="block text-sm font-medium text-gray-700 mb-2 font-['Outfit-medium']">
                                {{ 'JOB_APPLICATIONS.STATE' | translate }}
                              </label>
                              <select
                                formControlName="state"
                                class="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent appearance-none"
                              >
                                <option value="">{{ 'JOB_APPLICATIONS.STATE_PLACEHOLDER' | translate }}</option>

                                <optgroup label="United States">
                                  <option value="AL">Alabama</option>
                                  <option value="AK">Alaska</option>
                                  <option value="AZ">Arizona</option>
                                  <option value="AR">Arkansas</option>
                                  <option value="CA">California</option>
                                  <option value="CO">Colorado</option>
                                  <option value="CT">Connecticut</option>
                                  <option value="DE">Delaware</option>
                                  <option value="FL">Florida</option>
                                  <option value="GA">Georgia</option>
                                  <option value="HI">Hawaii</option>
                                  <option value="ID">Idaho</option>
                                  <option value="IL">Illinois</option>
                                  <option value="IN">Indiana</option>
                                  <option value="IA">Iowa</option>
                                  <option value="KS">Kansas</option>
                                  <option value="KY">Kentucky</option>
                                  <option value="LA">Louisiana</option>
                                  <option value="ME">Maine</option>
                                  <option value="MD">Maryland</option>
                                  <option value="MA">Massachusetts</option>
                                  <option value="MI">Michigan</option>
                                  <option value="MN">Minnesota</option>
                                  <option value="MS">Mississippi</option>
                                  <option value="MO">Missouri</option>
                                  <option value="MT">Montana</option>
                                  <option value="NE">Nebraska</option>
                                  <option value="NV">Nevada</option>
                                  <option value="NH">New Hampshire</option>
                                  <option value="NJ">New Jersey</option>
                                  <option value="NM">New Mexico</option>
                                  <option value="NY">New York</option>
                                  <option value="NC">North Carolina</option>
                                  <option value="ND">North Dakota</option>
                                  <option value="OH">Ohio</option>
                                  <option value="OK">Oklahoma</option>
                                  <option value="OR">Oregon</option>
                                  <option value="PA">Pennsylvania</option>
                                  <option value="RI">Rhode Island</option>
                                  <option value="SC">South Carolina</option>
                                  <option value="SD">South Dakota</option>
                                  <option value="TN">Tennessee</option>
                                  <option value="TX">Texas</option>
                                  <option value="UT">Utah</option>
                                  <option value="VT">Vermont</option>
                                  <option value="VA">Virginia</option>
                                  <option value="WA">Washington</option>
                                  <option value="WV">West Virginia</option>
                                  <option value="WI">Wisconsin</option>
                                  <option value="WY">Wyoming</option>
                                </optgroup>
  
                                <optgroup label="Canada">
                                  <option value="AB">Alberta</option>
                                  <option value="BC">British Columbia</option>
                                  <option value="MB">Manitoba</option>
                                  <option value="NB">New Brunswick</option>
                                  <option value="NL">Newfoundland and Labrador</option>
                                  <option value="NT">Northwest Territories</option>
                                  <option value="NS">Nova Scotia</option>
                                  <option value="NU">Nunavut</option>
                                  <option value="ON">Ontario</option>
                                  <option value="PE">Prince Edward Island</option>
                                  <option value="QC">Quebec</option>
                                  <option value="SK">Saskatchewan</option>
                                  <option value="YT">Yukon</option>
                                </optgroup>
                              </select>
                              <p *ngIf="f['state'].touched && f['state'].invalid" class="absolute text-red-500 text-sm mt-1">
                                {{ 'JOB_APPLICATIONS.STATE_REQUIRED' | translate }}
                              </p>
                            </div>

                            <!-- ZIP -->
                            <div class="relative">
                              <label class="block text-sm font-medium text-gray-700 mb-2 font-['Outfit-medium']">
                                {{ 'JOB_APPLICATIONS.ZIP' | translate }}
                              </label>
                              <input
                                type="text"
                                formControlName="zip"
                                placeholder="{{ 'JOB_APPLICATIONS.ZIP_PLACEHOLDER' | translate }}"
                                class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                              />
                              <p *ngIf="f['zip'].touched && f['zip'].invalid" class="absolute text-red-500 text-sm mt-1">
                                {{ 'JOB_APPLICATIONS.ZIP_REQUIRED' | translate }}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>

                  <!-- Form Builder -->
                  <div class="pl-10 pr-10 pb-10" *ngIf="!_applyJobStepperStatusService.addedSteps[_applyJobStepperStatusService.activeStep].isDefault && _applyJobStepperStatusService.addedSteps[_applyJobStepperStatusService.activeStep].previewMode == false">
                    <app-form-builder (savedForm)="saveCustomForm($event)"></app-form-builder>
                  </div>

                  <!-- Preview Form -->
                  <div class="pl-10 pr-10 pb-10" *ngIf="!_applyJobStepperStatusService.addedSteps[_applyJobStepperStatusService.activeStep].isDefault && _applyJobStepperStatusService.addedSteps[_applyJobStepperStatusService.activeStep].previewMode == true">
                    <div
                      class="flex items-center justify-center w-full pt-10"
                    >
                      <div
                        class="w-full h-full"
                        (click)="$event.stopPropagation()"
                      >
                        <div *ngIf="_applyJobStepperStatusService.addedSteps[_applyJobStepperStatusService.activeStep].description">
                          <div class="flex justify-between items-center">
                            <h2 class="text-2xl font-bold text-gray-900 mb-6 font-['Outfit-bold']">
                              {{_applyJobStepperStatusService.addedSteps[_applyJobStepperStatusService.activeStep].description}}
                            </h2>
                          </div>
                        </div>
                        <div>
                          <form class="space-y-4">
                            <div
                              *ngFor="let field of _applyJobStepperStatusService.addedSteps[_applyJobStepperStatusService.activeStep].fields; let i = index"
                              class="space-y-2 mb-8"
                            >
                              <label class="block text-sm font-medium text-gray-700 mb-2 font-['Outfit-medium']">
                                {{ field.label }}
                                <span *ngIf="field.required" class="text-red-500">*</span>
                              </label>

                              <div [ngSwitch]="field.type">
                                <input
                                  *ngSwitchCase="'text'"
                                  type="text"
                                  [placeholder]="field.placeholder || ''"
                                  [required]="field.required"
                                  class="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                                />
                                <input
                                  *ngSwitchCase="'email'"
                                  type="email"
                                  [placeholder]="field.placeholder || ''"
                                  [required]="field.required"
                                  class="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                                />
                                <input
                                  *ngSwitchCase="'phone'"
                                  type="tel"
                                  [placeholder]="field.placeholder || ''"
                                  [required]="field.required"
                                  class="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                                />
                                <input
                                  *ngSwitchCase="'number'"
                                  type="number"
                                  [placeholder]="field.placeholder || ''"
                                  [required]="field.required"
                                  class="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                                />
                                <textarea
                                  *ngSwitchCase="'textarea'"
                                  [placeholder]="field.placeholder || ''"
                                  [required]="field.required"
                                  rows="3"
                                  class="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                                ></textarea>
                                <textarea
                                  *ngSwitchCase="'about-textarea'"
                                  [placeholder]="field.placeholder || ''"
                                  [required]="field.required"
                                  rows="3"
                                  class="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                                ></textarea>
                                <select
                                  *ngSwitchCase="'select'"
                                  [required]="field.required"
                                  class="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                                >
                                  <option value="">{{ field.placeholder || 'Select an option' }}</option>
                                  <option *ngFor="let option of field.options" [value]="option">{{ option }}</option>
                                </select>
                                <div *ngSwitchCase="'checkbox'" class="space-y-2">
                                  <label *ngFor="let option of field.options" class="flex items-center space-x-2">
                                    <input type="checkbox" class="rounded border-gray-300 text-blue-600 focus:ring-blue-500">
                                    <span>{{ option }}</span>
                                  </label>
                                </div>
                                <div *ngSwitchCase="'radio'" class="space-y-2">
                                  <div class="grid grid-cols-2 gap-4">
                                    <button *ngFor="let option of field.options"
                                            type="button"
                                            (click)="setRadioBtnValue(i, option)"
                                            class="flex items-center justify-center px-6 py-4 border rounded-lg transition-colors"
                                            [ngClass]="[
                                              getRadioBtnValue(i) === option.toLowerCase() && option.toLowerCase() === 'no'
                                                ? 'border-red-300 bg-red-50'
                                                : getRadioBtnValue(i) === option.toLowerCase()
                                                  ? 'border-green-300 bg-green-50'
                                                  : 'border-gray-300 hover:border-blue-300'
                                            ]">

                                      <!-- Checkmark only if this option is selected -->
                                      <svg *ngIf="getRadioBtnValue(i) === option.toLowerCase()"
                                          class="w-5 h-5 mr-2" [ngClass]="[
                                              getRadioBtnValue(i) === option.toLowerCase() && option.toLowerCase() === 'no'
                                                ? 'text-red-600'
                                                : getRadioBtnValue(i) === option.toLowerCase()
                                                  ? 'text-green-600'
                                                  : 'text-red-600'
                                            ]"
                                          fill="currentColor" viewBox="0 0 20 20">
                                        <path fill-rule="evenodd"
                                              d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                              clip-rule="evenodd"></path>
                                      </svg>

                                      <span>{{ option }}</span>
                                    </button>
                                  </div>
                                </div>
                                <input
                                  *ngSwitchCase="'date'"
                                  type="date"
                                  [required]="field.required"
                                  class="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                                />
                                <div *ngSwitchCase="'file'">
                                  <app-your-bio></app-your-bio>
                                <!-- <input
                                  type="file"
                                  [required]="field.required"
                                  class="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                                /> -->
                                </div>
                                <div *ngSwitchCase="'video'">
                                  <app-video></app-video>
                                </div>
                                <div *ngSwitchCase="'tags'">
                                  <div class="w-full">
                                    <!-- Selected count -->
                                    <div class="mb-8">
                                      <div class="mt-4 flex items-center gap-2">
                                        <div class="flex gap-1">
                                          <div class="w-10 h-10 rounded-full flex items-center justify-center text-sm font-semibold transition-all duration-300 scale-100" [ngClass]="selectedTags['undefined']?.length && selectedTags['undefined'].length >= 1 ? 'bg-blue-600 text-white' : 'bg-slate-200 text-slate-400'">
                                            1
                                          </div>
                                          <div class="w-10 h-10 rounded-full flex items-center justify-center text-sm font-semibold transition-all duration-300 scale-100" [ngClass]="selectedTags['undefined']?.length && selectedTags['undefined'].length >= 2 ? 'bg-blue-600 text-white' : 'bg-slate-200 text-slate-400'">
                                            2
                                          </div>
                                          <div class="w-10 h-10 rounded-full flex items-center justify-center text-sm font-semibold transition-all duration-300 scale-100" [ngClass]="selectedTags['undefined']?.length && selectedTags['undefined'].length >= 3 ? 'bg-blue-600 text-white' : 'bg-slate-200 text-slate-400'">
                                            2
                                          </div>
                                        </div>
                                        <span class="text-slate-500 text-sm ml-2">
                                          0/3 selected
                                        </span>
                                      </div>
                                    </div>

                                    <!-- Buttons grid -->
                                    <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8">
                                      <button
                                        *ngFor="let option of field.options"
                                        type="button"
                                        class="relative flex justify-between px-5 py-4 rounded-xl border-2 transition-all duration-200"
                                        [ngClass]="{
                                          'border-blue-600 bg-blue-50 text-blue-900': selectedTags[field.id]?.includes(option),
                                          'bg-white text-gray-700 border-gray-300': !selectedTags[field.id]?.includes(option)
                                        }"
                                        (click)="toggleTag(field.id, option)"
                                      >
                                        <span class="font-medium">{{ option }}</span>
                                        <div
                                          *ngIf="selectedTags[field.id]?.includes(option)"
                                          class="w-6 h-6 bg-blue-600 rounded-full flex items-center justify-center animate-in zoom-in duration-200"
                                        >
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            stroke-width="3"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            class="lucide lucide-check w-4 h-4 text-white"
                                          >
                                            <path d="M20 6 9 17l-5-5"></path>
                                          </svg>
                                        </div>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </form>
                          <button
                            (click)="editStep()"
                            class="w-[200px] font-medium float-right rounded-lg px-4 py-3 mt-8 bg-blue-500 hover:bg-blue-100 text-blue-100 hover:text-blue-700"
                          >
                            Edit
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
         </div>
      </main>
    </div>
  </div>
</div>
